import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import classNames from 'classnames';
import * as React from 'react';

const style = require('./index.css');

export interface IMortgageProps {
  context: IAdFoxBannerContext;
}

export const MortgageBanner: React.FC<IMortgageProps> = ({ context }) => {
  return (
    <a
      href={context.link}
      target="_blank"
      className={classNames([style['link'], style['link-simplified']])}
      rel="nofollow noopener noreferrer"
    >
      {context.name}
      <span className={style['title']}>Рассчитать ипотеку</span>
    </a>
  );
};
